import React from 'react';

interface DeleteAccountSuccessModalProps {
    show: boolean;
    onAcknowledge: () => void;
}

const DeleteAccountSuccessModal: React.FC<DeleteAccountSuccessModalProps> = ({ show, onAcknowledge }) => {
    if (!show) return null;

    return (
        <div className="fixed inset-0 bg-black/60 z-[260] backdrop-blur-xs flex items-center justify-center p-4 text-left">
            <div className="bg-[#2d312e] text-white rounded-2xl p-6 max-w-xs w-full shadow-2xl border border-neutral-700 text-center animate-in zoom-in-95 duration-150">
                <div className="w-12 h-12 bg-green-500/10 text-green-400 rounded-full flex items-center justify-center mx-auto mb-3.5">
                    <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}><path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" /></svg>
                </div>
                <h3 className="text-lg font-bold text-white mb-1.5" style={{ fontFamily: 'Comic Sans MS, Comic Sans, cursive' }}>Success</h3>
                <p className="text-gray-300 text-xs font-medium mb-5">Your account record has been completely erased.</p>
                <button type="button" onClick={onAcknowledge} className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-2 rounded-xl text-xs transition-colors shadow-md">OK</button>
            </div>
        </div>
    );
};

export default DeleteAccountSuccessModal;
